import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

export default function Empleados() {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const [empleados, setEmpleados] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ nombre: '', email: '', password: '', cargo: '', coste_hora: '', es_externo: false, con_acceso: false });
  const [error, setError] = useState('');
  const [sortCol, setSortCol] = useState('nombre');
  const [sortDir, setSortDir] = useState('asc');

  const toggleSort = (col) => {
    if (sortCol === col) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortCol(col); setSortDir('asc'); }
  };

  const sorted = [...empleados].sort((a, b) => {
    let va = a[sortCol] ?? '';
    let vb = b[sortCol] ?? '';
    if (typeof va === 'string') va = va.toLowerCase();
    if (typeof vb === 'string') vb = vb.toLowerCase();
    if (va < vb) return sortDir === 'asc' ? -1 : 1;
    if (va > vb) return sortDir === 'asc' ? 1 : -1;
    return 0;
  });

  const SortTh = ({col, label}) => (
    <th style={{...styles.th, cursor:'pointer', userSelect:'none', whiteSpace:'nowrap'}} onClick={() => toggleSort(col)}>
      {label} {sortCol === col ? (sortDir === 'asc' ? '↑' : '↓') : <span style={{color:'#ddd'}}>↕</span>}
    </th>
  );

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    API.get('/empleados').then(res => {
      setEmpleados(res.data);
      setCargando(false);
    }).catch(() => setCargando(false));
  };

  const guardar = async () => {
    setError('');
    if (!form.nombre.trim()) { setError('El nombre es obligatorio'); return; }
    if (form.con_acceso) {
      if (!form.email.trim()) { setError('El email es obligatorio para dar acceso'); return; }
      if (!form.password.trim()) { setError('La contraseña es obligatoria para dar acceso'); return; }
      if (form.password.length < 6) { setError('La contraseña debe tener al menos 6 caracteres'); return; }
    }
    try {
      if (form.con_acceso) {
        await API.post('/empleados/con-usuario', {
          nombre: form.nombre,
          email: form.email,
          password: form.password,
          cargo: form.cargo || null,
          coste_hora: form.coste_hora ? parseFloat(form.coste_hora) : null,
          es_externo: form.es_externo,
        });
      } else {
        await API.post('/empleados', {
          nombre: form.nombre,
          email: form.email || null,
          cargo: form.cargo || null,
          coste_hora: form.coste_hora ? parseFloat(form.coste_hora) : null,
          es_externo: form.es_externo,
        });
      }
      setModal(false);
      cargar();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al guardar');
    }
  };

  const initials = (nombre) => nombre?.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase() || '?';

  if (cargando) return <div style={styles.loading}>Cargando...</div>;

  return (
    <div style={styles.page}>
      <div style={styles.topbar}>
        <div style={styles.topbarTitle}>Empleados</div>
        {usuario?.rol === 'admin' && (
          <button style={styles.btn} onClick={() => { setForm({ nombre: '', email: '', password: '', cargo: '', coste_hora: '', es_externo: false, con_acceso: false }); setError(''); setModal(true); }}>
            + Añadir empleado
          </button>
        )}
      </div>

      <div style={styles.content}>
        {empleados.length === 0 ? (
          <div style={styles.empty}>
            <div style={styles.emptyText}>No hay empleados aún</div>
            {usuario?.rol === 'admin' && <button style={styles.btn} onClick={() => setModal(true)}>Añadir primer empleado</button>}
          </div>
        ) : (
          <div style={styles.card}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <SortTh col="nombre" label="Empleado" />
                  <SortTh col="es_externo" label="Tipo" />
                  <SortTh col="horas_mes" label="Horas este mes" />
                  <SortTh col="activo" label="Estado" />
                </tr>
              </thead>
              <tbody>
                {sorted.map(emp => (
                  <tr key={emp.id} style={styles.tr} onClick={() => navigate(`/empleados/${emp.id}`)} onMouseEnter={e => e.currentTarget.style.background='#fafaf8'} onMouseLeave={e => e.currentTarget.style.background='white'}>
                    <td style={styles.td}>
                      <div style={styles.empRow}>
                        <div style={{...styles.avatar, background: emp.es_externo ? '#F5EFD6' : '#E6F1FB', color: emp.es_externo ? '#8B6914' : '#185FA5'}}>
                          {initials(emp.nombre)}
                        </div>
                        <span style={styles.empNombre}>{emp.nombre}</span>
                      </div>
                    </td>
                    <td style={styles.td}>
                      <span style={emp.es_externo ? styles.pillExterno : styles.pillInterno}>
                        {emp.es_externo ? 'Externo' : 'Interno'}
                      </span>
                    </td>
                    <td style={styles.td}>
                      <span style={styles.muted}>{emp.horas_mes ?? '—'}h</span>
                    </td>
                    <td style={styles.td}>
                      <span style={emp.activo ? styles.pillActive : styles.pillInactive}>
                        {emp.activo ? 'Activo' : 'Inactivo'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {modal && (
        <div style={styles.overlay} onClick={() => setModal(false)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}>Nuevo empleado</div>
              <button style={styles.closeBtn} onClick={() => setModal(false)}>✕</button>
            </div>
            {error && <div style={styles.errorBox}>{error}</div>}
            <div style={styles.field}>
              <label style={styles.label}>Nombre completo *</label>
              <input style={styles.input} value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} placeholder="Ana García López" />
            </div>
            <div style={styles.field}>
              <label style={{...styles.label, display:'flex', alignItems:'center', gap:8, cursor:'pointer'}}>
                <input type="checkbox" checked={form.con_acceso} onChange={e => setForm({...form, con_acceso: e.target.checked, email:'', password:''})} />
                Dar acceso a la app (email + contraseña)
              </label>
            </div>
            {form.con_acceso && <>
            <div style={styles.field}>
              <label style={styles.label}>Email de acceso *</label>
              <input style={styles.input} type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="ana@empresa.com" />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Contraseña *</label>
              <input style={styles.input} type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="Mínimo 6 caracteres" />
              <div style={{fontSize:11,color:'#aaa',marginTop:4}}>El empleado usará estas credenciales para entrar a la app</div>
            </div>
            </>}
            <div style={styles.field}>
              <label style={styles.label}>Cargo</label>
              <input style={styles.input} value={form.cargo} onChange={e => setForm({...form, cargo: e.target.value})} placeholder="Desarrollador, Diseñador..." />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Coste hora (€)</label>
              <input style={styles.input} type="number" value={form.coste_hora} onChange={e => setForm({...form, coste_hora: e.target.value})} placeholder="25" />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Tipo</label>
              <select style={styles.input} value={form.es_externo} onChange={e => setForm({...form, es_externo: e.target.value === 'true'})}>
                <option value="false">Interno</option>
                <option value="true">Externo / Colaborador</option>
              </select>
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.btnSecondary} onClick={() => setModal(false)}>Cancelar</button>
              <button style={styles.btn} onClick={guardar}>Crear empleado</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  page: { display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#f5f5f3', fontFamily: '-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  loading: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#aaa', fontSize: 14 },
  topbar: { background: 'white', borderBottom: '0.5px solid #e0e0d8', padding: '0 24px', height: 48, display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  topbarTitle: { fontSize: 14, fontWeight: 500, color: '#1a1a1a' },
  content: { padding: 24 },
  card: { background: 'white', border: '0.5px solid #e0e0d8', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { padding: '10px 16px', fontSize: 11, fontWeight: 500, color: '#aaa', textAlign: 'left', borderBottom: '0.5px solid #f0f0ed', textTransform: 'uppercase', letterSpacing: '0.05em' },
  tr: { borderBottom: '0.5px solid #f0f0ed', cursor: 'pointer', background: 'white', transition: 'background 0.1s' },
  td: { padding: '12px 16px', fontSize: 13, color: '#1a1a1a', verticalAlign: 'middle' },
  empRow: { display: 'flex', alignItems: 'center', gap: 10 },
  avatar: { width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 600, flexShrink: 0 },
  empNombre: { fontWeight: 500 },
  muted: { color: '#888' },
  pillActive: { background: '#EAF3DE', color: '#3B6D11', fontSize: 11, padding: '2px 8px', borderRadius: 10, fontWeight: 500 },
  pillInactive: { background: '#f0f0ed', color: '#aaa', fontSize: 11, padding: '2px 8px', borderRadius: 10 },
  pillInterno: { background: '#E6F1FB', color: '#185FA5', fontSize: 11, padding: '2px 8px', borderRadius: 10, fontWeight: 500 },
  pillExterno: { background: '#F5EFD6', color: '#8B6914', fontSize: 11, padding: '2px 8px', borderRadius: 10, fontWeight: 500 },
  btn: { background: '#378ADD', color: 'white', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 500, cursor: 'pointer' },
  btnSecondary: { background: 'white', color: '#666', border: '0.5px solid #d0d0c8', borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer' },
  empty: { textAlign: 'center', padding: '64px 0' },
  emptyText: { fontSize: 14, color: '#aaa', marginBottom: 16 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: 'white', borderRadius: 12, border: '0.5px solid #e0e0d8', padding: 24, width: '100%', maxWidth: 440 },
  modalHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 },
  modalTitle: { fontSize: 15, fontWeight: 500, color: '#1a1a1a' },
  closeBtn: { background: 'none', border: 'none', fontSize: 16, cursor: 'pointer', color: '#aaa' },
  errorBox: { background: '#FCEBEB', color: '#A32D2D', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 16 },
  field: { marginBottom: 16 },
  label: { display: 'block', fontSize: 13, color: '#444', marginBottom: 6, fontWeight: 500 },
  input: { width: '100%', padding: '9px 12px', borderRadius: 8, border: '0.5px solid #d0d0c8', fontSize: 14, outline: 'none', boxSizing: 'border-box', background: 'white' },
  modalFooter: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 24 },
};
